import React, { useState } from "react";
import SheetInformation from "./BasicInformation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../global";
import FileToSpreadsheetModalSelect from "../Utils/FileToSpreadsheetModalSelect";
import WeightBreakColumns from "./WeightBreakColumns";
import Surcharge from "./Surcharge";
import { toast } from "react-toastify";

export default function FileAccordion({
  file,
  metadata,
  sheetList,
  onUpdateMetadata,
  onDeleteMetadata,
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isOpenSelectingExcel, setIsOpenSelectingExcel] = useState(false);

  const [activeExcelField, setActiveExcelField] = useState(null);

  const [activeExcelIndex, setActiveExcelIndex] = useState(null);
  const [activeExcelType, setActiveExcelType] = useState(null);

  const [selectionType, setSelectionType] = useState("all");

  const excelSelectionTypeMap = {
    first_row: "row",
    ratecard: "column",
    service: "column",
    from_zone: "column",
    to_zone: "column",
    reciprocal: "column",
    cubic_conversion: "column",
    basic: "column",
    minimum: "column",
    price_buy: "column",
    price_sell: "column",
  };

  function openExcelModalForField(key) {
    const selectionType = excelSelectionTypeMap[key] || "all";
    setActiveExcelField(key);
    setActiveExcelIndex(null);
    setActiveExcelType(null);
    setSelectionType(selectionType);
    setIsOpenSelectingExcel(true);
  }

  function openExcelModalForIndex(index, type, key) {
    const selectionType = excelSelectionTypeMap[key] || "all";
    setActiveExcelIndex(index);
    setActiveExcelType(type);
    setActiveExcelField(key);
    setSelectionType(selectionType);
    setIsOpenSelectingExcel(true);
  }

  function closeModal() {
    setIsOpenSelectingExcel(false);
    setActiveExcelField(null);
    setActiveExcelIndex(null);
    setSelectionType("all");
    setActiveExcelType(null);
  }

  function onSelectRange(value) {
    if (activeExcelType === null) {
      handleSheetChange(activeExcelField, value);
    } else if (activeExcelIndex !== null && activeExcelType !== null) {
      if (activeExcelType === "weight_break") {
        handleWeightBreakColumnChange(
          activeExcelIndex,
          activeExcelField,
          value
        );
      }
    }
    closeModal();
  }

  const handleSheetNameChange = async (name) => {
    var updated = {
      ...metadata,
      sheet_information: {
        ...metadata.sheet_information,
        sheet_name: name,
      },
    };

    if (
      !metadata.surcharges ||
      metadata.surcharges.length === 0 ||
      metadata.surcharges.every((surcharge) => surcharge.name === "")
    ) {
      var response = await fetch("./data/surchargeData.json");

      const surchargeDefault = await response.json();

      var filteredSurcharge = surchargeDefault.filter(
        (x) =>
          typeof name === "string" &&
          typeof x.carrier === "string" &&
          (name.includes(x.carrier) || x.carrier.includes(name)) &&
          x.carrier !== ""
      );

      var updatedSurcharge = [];
      filteredSurcharge.forEach((surcharge) => {
        updatedSurcharge.push({
          name: surcharge.type,
          description: surcharge.type,
          buy_rate: surcharge.cost,
          sell_rate: surcharge.charge,
        });
      });

      updated = {
        ...updated,
        surcharges: [...updated.surcharges, ...updatedSurcharge],
      };
      toast.success("Default Surcharges have been applied!");
    }

    onUpdateMetadata(updated);
  };

  const handleOverwriteSheet = (value) => {
    const updated = {
      ...metadata,
      sheet_information: {
        ...metadata.sheet_information,
        overwrite_sheet: value,
      },
    };
    onUpdateMetadata(updated);
  };

  const handleSheetChange = (key, value) => {
    const updated = {
      ...metadata,
      sheet_information: {
        ...metadata.sheet_information,
        [key]: value,
      },
    };
    onUpdateMetadata(updated);
  };

  const handleWeightBreakColumnChange = (index, key, value) => {
    const updatedBuffers = [...metadata.weight_break_columns];
    updatedBuffers[index][key] = value;
    const updated = { ...metadata, weight_break_columns: updatedBuffers };
    onUpdateMetadata(updated);
  };

  const addWeightBreakColumn = () => {
    const updated = {
      ...metadata,
      weight_break_columns: [
        ...metadata.weight_break_columns,
        {
          break_type: "",
          item_type: "",
          break_from: "",
          break_to: "",
          price_buy: "",
          price_sell: "",
        },
      ],
    };
    onUpdateMetadata(updated);
  };

  const removeWeightBreakColumn = (index) => {
    const updatedBuffers = metadata.weight_break_columns.filter(
      (_, i) => i !== index
    );
    const updated = { ...metadata, weight_break_columns: updatedBuffers };
    onUpdateMetadata(updated);
  };

  const handleSurchargeColumnChange = (index, key, value) => {
    const updatedBuffers = [...metadata.surcharges];
    updatedBuffers[index][key] = value;
    const updated = { ...metadata, surcharges: updatedBuffers };
    onUpdateMetadata(updated);
  };

  const addSurchargeColumn = () => {
    const updated = {
      ...metadata,
      surcharges: [
        ...metadata.surcharges,
        {
          name: "",
          description: "",
          buy_rate: "",
          sell_rate: "",
        },
      ],
    };
    onUpdateMetadata(updated);
  };

  const removeSurchargeColumn = (index) => {
    const updatedBuffers = metadata.surcharges.filter((_, i) => i !== index);
    const updated = { ...metadata, surcharges: updatedBuffers };
    onUpdateMetadata(updated);
  };

  return (
    <>
      {isOpenSelectingExcel && file && (
        <FileToSpreadsheetModalSelect
          file={file}
          closeModal={closeModal}
          metadata={metadata}
          onSubmit={onSelectRange}
          selectionType={selectionType}
        />
      )}

      <div
        className="mb-4 overflow-hidden rounded-lg shadow-sm m-3 border"
        style={{
          borderColor: colors.primary,
          borderRadius: "0.5rem",
        }}
      >
        {/* Header */}
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex flex-wrap justify-between items-center p-3 gap-y-2 cursor-pointer rounded-lg"
          style={{ backgroundColor: colors.accent, color: colors.white }}
        >
          <span className="font-medium text-sm truncate max-w-[60%] sm:max-w-[80%]">
            {metadata.id}
          </span>

          <div className="flex flex-wrap gap-2 sm:gap-2 items-center">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDeleteMetadata(metadata.id);
              }}
              className="bg-white rounded-full w-8 h-8 flex items-center justify-center hover:opacity-90 transition-opacity"
              style={{ color: colors.primary }}
              aria-label="Delete metadata"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>

            <button
              onClick={(e) => e.stopPropagation()}
              className="text-white w-8 h-8 flex items-center justify-center"
              aria-label={isExpanded ? "Collapse" : "Expand"}
            >
              <FontAwesomeIcon
                icon={isExpanded ? faChevronUp : faChevronDown}
              />
            </button>
          </div>
        </div>

        {/* Expanded content */}
        {isExpanded && (
          <div className="p-4 space-y-6 bg-gray-50">
            <SheetInformation
              sheetList={sheetList}
              metadata={metadata}
              handleSheetChange={handleSheetChange}
              handleSheetNameChange={handleSheetNameChange}
              handleOverwriteSheet={handleOverwriteSheet}
              openExcelModal={openExcelModalForField}
              excelSelectableFields={[
                "first_row",
                "carrier",
                "ratecard",
                "service",
                "from_zone",
                "to_zone",
                "reciprocal",
                "cubic_conversion",
                "basic_buy",
                "basic_sell",
                "minimum_buy",
                "minimum_sell",
              ]}
            />

            <WeightBreakColumns
              metadata={metadata}
              handleWeightBreakColumnChange={handleWeightBreakColumnChange}
              removeWeightBreakColumn={removeWeightBreakColumn}
              addWeightBreakColumn={addWeightBreakColumn}
              openExcelModal={(index, key) =>
                openExcelModalForIndex(index, "weight_break", key)
              }
              excelSelectableFields={["price_buy", "price_sell"]}
            />
            <Surcharge
              metadata={metadata}
              handleSurchargeColumnChange={handleSurchargeColumnChange}
              removeSurchargeColumn={removeSurchargeColumn}
              addSurchargeColumn={addSurchargeColumn}
              openExcelModal={(index, key) =>
                openExcelModalForIndex(index, "surcharge", key)
              }
              excelSelectableFields={["price_buy", "price_sell"]}
            />
          </div>
        )}
      </div>
    </>
  );
}
